import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getFoodcompositionList } from 'components/foodcomposition/FoodcompositionAPI';
import { setFoodcompositionList, setFoodcompositionDashboardFoodcompositionList } from 'store/slice/PharmaSlice';
import FoodcompositionDashboard from '../FoodcompositionDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function FoodcompositionPageImpl() {
    const dispatch = useDispatch();
    const { foodcompositionList} = useSelector((state)=>state.pharmaslice);
    
    const getFoodcompositionListSuccess = (list) =>{dispatch(setFoodcompositionList(list));}
    useEffect(() => {
        getFoodcompositionList(()=>{}, getFoodcompositionListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setFoodcompositionDashboardFoodcompositionList( foodcompositionList));
    },[ foodcompositionList])

    return (
        < FoodcompositionDashboard />
    )

}